import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: "Does this replace my evaluation or a student's individual goals?",
  a: "No. It supports your clinical judgment. You choose each student's row and level from their own goals (IEP, EHCP, ILP, IPP or equivalent); the pack gives you the session to run them in. It does not replace assessment or individual planning."
}, {
  q: 'My groups are really mixed. Will every student have something to work on?',
  a: 'Every grid has four rows — Sound, Word, Sentence and Social — each at three levels, so each student in the group gets a row. Students with fluency or AAC goals join the existing rows: page 2 of each volume and Bonus 05 show how. We don’t promise to cover every possible goal; we promise a row for every student in the group.'
}, {
  q: 'What ages is it for?',
  a: 'Students aged 5 to 11 (K–5 in the US, Reception to Year 6 in the UK). The Start level works for pre-readers with the picture strip; Stretch moves into longer, independent practice.'
}, {
  q: 'Which sounds are covered?',
  a: 'Every theme has a sound bank for the 9 most-targeted sound groups: /k g/, /f v/, /s z/, /ʃ tʃ dʒ/, /l/, prevocalic /r/, vocalic /r/, /θ ð/, and s-, l- and r-blends — with word position marked where the theme allows and a carrier phrase for each.'
}, {
  q: 'I already have a folder full of materials. Why would I need this?',
  a: 'More materials give you more pages. This gives you a structure: one page that fits the whole group, and a full school year of it, in order. It’s a single payment, and you can keep bringing your favorite activities into the grid.'
}, {
  q: 'Do I have to start at Volume 1?',
  a: 'No. Each volume stands alone and explains the whole system on pages 2 to 4. Bonus 01, Quick-Start, walks you through your first week wherever you start.'
}, {
  q: "I'm in the UK, Australia or Canada. Will it fit?",
  a: 'Yes. It uses neutral terms (“goal”, “student”) with a quick US / UK / Australia / Canada terms table on page 2, no single-country holidays or seasons, and volumes numbered by weeks instead of months. Spelling is US English.'
}, {
  q: 'Do I need to print in color, cut or laminate?',
  a: 'No. Every row carries a text label (SND, WRD, SEN, SOC), so pages work in black and white. Use them on screen — teletherapy included — or print once.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="w-full bg-cream text-ink" data-id="element-87" data-mp="1zg7k1b0yb17e">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-88" data-mp="1zia6jl2wac7d">
        <div className="text-center" data-id="element-89" data-mp="s35k879fayxg">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-90" data-mp="s0188nppuyw8">
            Before you buy
          </p>
          <h2 id="faq-heading" className="mt-3 font-display text-plum text-3xl sm:text-5xl" data-id="element-91" data-mp="2zox86z45mia7">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-92" data-mp="38ok97jsz1m2q">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl border border-cream-dark bg-white" data-id="element-93" data-mp="3dgtwst6m6a1u" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left text-[15px] font-semibold text-plum focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-deep" data-id="element-94" data-mp="3nd6wc7oubi4i">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-95" data-mp="220vq2vyws03s" /> : <PlusIcon className="h-5 w-5 flex-none text-gold-deep" aria-hidden="true" data-id="element-96" data-mp="11qawt00akdz4" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-ink-soft" data-id="element-97" data-mp="1bn7cbpoly0d6">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}